
import { canonical } from "@utils";
import { getCMSCopy } from "@/common/services/cmsCopyService";

export default {
	name: "Reviews",
	data() {
		return {
			pageTitle: "",
			pageHeading: "",
			pageContent: "",
			pageMetaTitle: "",
			pageMetaDescription: "",
		};
	},
	// fetch: content loading (SSR + client nav). Non-blocking on the client, so
	// navigating here no longer freezes the route transition.
	async fetch() {
		await this.loadData();
	},
	head() {
		return {
			title: this.pageMetaTitle,
			meta: [
				{
					name: "description",
					content: this.pageMetaDescription,
				},
			],
			link: [canonical(this.$route)],
		};
	},
	methods: {
		async loadData() {
			const cmsCopy = await getCMSCopy(
				this.$axios,
				this.$config,
				".seo.landing.reviews",
				process.env.version
			);

			this.pageTitle = cmsCopy?.data?.title || "";
			this.pageHeading = cmsCopy?.data?.teaser || "";
			this.pageContent = cmsCopy?.data?.body || "";
			this.pageMetaTitle = cmsCopy?.data?.metaTitle || "";
			this.pageMetaDescription = cmsCopy?.data?.metaDescription || "";
		},
	},
};
